module.exports = __webpack_public_path__ + "static/media/S-12-Y.0fc854c4.mp3";